import * as React from "react"
import Container from "../container/container"
import { Link } from "gatsby"
import * as styles from "./latest.module.scss"
import Markdown from "react-markdown"

const LatestNews = props => {
  const news = props.data.slice(0, 4)
  return (
    <div className={styles.latest}>
      <Container>
        <h2>Latest Blogs</h2>
        <p>Take a look at our latest blog posts</p>

        <div
          className={`${styles.latest__news} d-flex align-items-start justify-content-evenly`}
        >
          {news.map((item, key) => (
            <Link
              to={`/blog/${item.node.Slug}`}
              key={key}
              className={styles.latest__news__item}
            >
              <div
                className={styles.latest__news__item__bg}
                style={{
                  backgroundImage: `url(${item.node.FeaturedImage.publicURL})`,
                }}
              ></div>
              <h3>{item.node.Heading}</h3>
              <Markdown>{item.node.Body.substring(0, 100) + ".."}</Markdown>
            </Link>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default LatestNews
